import React from 'react';
import { motion } from 'framer-motion';

export function TimelineContent({
  as = 'div',
  children,
  className = '',
  animationNum = 0,
  customVariants,
  timelineRef,
  style,
  ...props
}) {
  const Component = motion[as] || motion.div;

  const defaultVariants = {
    visible: (i) => ({
      y: 0,
      opacity: 1,
      filter: 'blur(0px)',
      transition: {
        delay: i * 0.12,
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
    hidden: {
      filter: 'blur(10px)',
      y: 20,
      opacity: 0,
    },
  };

  const variants = customVariants || defaultVariants;

  return (
    <Component
      className={className}
      custom={animationNum}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-40px' }}
      variants={variants}
      style={style}
      {...props}
    >
      {children}
    </Component>
  );
}

export default TimelineContent;
